export const LCMethods = {
  groupByConsistId: (locomotiveList) => {
    const consistMap = {};
    const unassigned = [];

    locomotiveList.forEach((loco) => {
      if (loco.assignedConsist && loco.assignedConsist.consistNumber) {
        const cid = loco.assignedConsist.consistNumber;
        if (!consistMap[cid]) {
          consistMap[cid] = [];
        }
        consistMap[cid].push(loco);
      } else {
        unassigned.push(loco);
      }
    });
    for (let key in consistMap) {
      let assetArr = consistMap[key].sort((a, b) => a.assignedConsist.order - b.assignedConsist.order);
      consistMap[key] = assetArr;
    }
    return {
      consists: consistMap,
      unassigned,
    };
  },
  getInProgressAssetIds: (inProgressJPlan = [], assetIds = []) => {
    let ids = [];
    for (let jp of inProgressJPlan) {
      let task = jp.tasks[0];
      let units = task.units;
      for (let i = 1; i < units.length; i++) {
        let asset = units[i];
        if (assetIds.includes(asset.id) && !ids.includes(asset.id)) {
          ids.push(asset.id);
        }
      }
    }
    return ids;
  },
};



// WEBPACK FOOTER //
// ./src/components/Consist/AssetConsistMethods.js